enum PartyRole {
  Songwriter = 'Songwriter',
  Producer = 'Producer',
  CoProducer = 'Co Producer',
  Engineer = 'Engineer',
}

export default PartyRole;
